import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/Style/Style.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'rsuite/styles/index.less';
import 'rsuite/Container/styles/index.css';
import 'rsuite/Header/styles/index.css';
import 'rsuite/Content/styles/index.css';
import 'rsuite/Footer/styles/index.css';
import 'rsuite/Sidebar/styles/index.css';
import 'rsuite/Grid/styles/index.css';
import 'rsuite/Row/styles/index.css';
import 'rsuite/Col/styles/index.css';
import 'rsuite/Button/styles/index.css';
import 'rsuite/ButtonGroup/styles/index.css';
import 'rsuite/ButtonToolbar/styles/index.css';
import 'rsuite/useToaster/styles/index.css';
//import 'rsuite/dist/rsuite.min.css';
import 'rsuite/dist/rsuite-rtl.min.css';
//import "react-modern-calendar-datepicker/lib/DatePicker.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
